import {createApp} from 'vue'
import SourceExternalLinks from './SourceExternalLinks'

const el = '.kb-component--source-external-links'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((SourceExternalLinksDOM)=>{
            const props = {
                name: SourceExternalLinksDOM.dataset.name,
                links: JSON.parse(SourceExternalLinksDOM.dataset.links),
            }
            const component = createApp(SourceExternalLinks, props).use(Store)
            component.mount(SourceExternalLinksDOM)
        })
    }
}